import {
  EmailOutlined,
  Phone,
  LinkedIn,
  GitHub,
  WhatsApp,
} from "@mui/icons-material";
import styles from "./Icons.module.css";
function Icons() {
  return (
    <ul className={styles.IconMenu}>
      <li>
        <a
          href="https://github.com/akanbijr/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <GitHub
            className={`${styles.IconMenuItem} ${styles.icon} ${styles.largeIcon}`}
          />
        </a>
      </li>
      <li>
        <a
          href="https://www.linkedin.com/in/akanbijr"
          target="_blank"
          rel="noopener noreferrer"
        >
          <LinkedIn
            className={`${styles.IconMenuItem} ${styles.icon} ${styles.largeIcon}`}
          />
        </a>
      </li>
      <li>
        <a href="tel:+234(0)9094437156">
          <Phone
            className={`${styles.IconMenuItem} ${styles.icon} ${styles.largeIcon}`}
          />
        </a>
      </li>
      <li>
        <a href="mailto:hello@akanbijr.com">
          <EmailOutlined
            className={`${styles.IconMenuItem} ${styles.icon} ${styles.largeIcon}`}
          />
        </a>
      </li>
      <li>
        <a
          href="https://wa.link/8b0d64"
          target="_blank"
          rel="noopener noreferrer"
        >
          <WhatsApp
            className={`${styles.IconMenuItem} ${styles.icon} ${styles.largeIcon}`}
          />
        </a>
      </li>
      {/* <li>
        <DarkMode className={`${styles.IconMenuItem} ${styles.icon}`} />
      </li> */}
    </ul>
  );
}

export default Icons;
